module.exports = __webpack_public_path__ + "static/img/our-people-company-programs-stepping.050d54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-programs-stepping.jpg
// module id = cdb3
// module chunks = 0